<template>
  <div>
    <el-dialog class="rightDetailModal shopRightDetail" :visible.sync="modalInfo.isShow" v-if="modalInfo.isShow"
      width="840px">
      <div slot="title" class="shop-header">
        <h3 class="shop-name" v-if="modalInfo.detail.dealername">{{ modalInfo.detail.dealername }}</h3>
        <div>
          <div style="float: left;width: 600px;border-right: 1px solid #eee;margin-top: 8px;">
            <div style="float: left;margin-bottom: 8px;width: 600px;">
              <img style="float: left;margin-right: 16px;width: 24px;height: 24px;"
                src="@/assets/img/login/login_acc.png" />
              <div style="float: left;width: 60px;font-size: 14px;">
                用户名
              </div>
              <div style="float: left;margin-right: 16px;">
                {{ modalInfo.detail.username }}
              </div>
              <div style="float: left;font-size: 14px;">
                <span class="state" :class="modalInfo.detail.status == 1 ? 'active-state' : 'inactive-state'">{{
                  modalInfo.detail.status ==
                    1 ? '已启用' : '未启用' }}</span>
              </div>
              <div style="float: right;margin-right: 16px;">
                <el-switch v-model="switchValue" @change="switchShow">
                </el-switch>
              </div>
            </div>
            <div style="float: left;margin-bottom: 8px;width: 600px;">
              <img style="float: left;margin-right: 16px;width: 24px;height: 24px;"
                src="@/assets/img/login/newWx.png" />
              <div style="float: left;width: 60px;font-size: 14px;">
                微信
              </div>
              <div style="float: left;margin-right: 16px;font-size: 14px;">
                {{ modalInfo.detail.nickname ? modalInfo.detail.nickname : '未绑定' }}
              </div>
            </div>
            <div style="float: left;margin-bottom: 8px;width: 600px;">
              <img style="float: left;margin-right: 16px;width: 24px;height: 24px;"
                src="@/assets/img/login/phone.png" />
              <div style="float: left;width: 60px;font-size: 14px;">
                手机
              </div>
              <div style="float: left;margin-right: 16px;font-size: 14px;">
                {{ modalInfo.detail.mobile != '' ? modalInfo.detail.mobile : '未绑定' }}
              </div>
            </div>
            <div style="float: left;margin-bottom: 8px;width: 600px;">
              <img style="float: left;margin-right: 16px;width: 24px;height: 24px;"
                src="@/assets/img/login/email.png" />
              <div style="float: left;width: 60px;font-size: 14px;">
                邮箱
              </div>
              <div style="float: left;margin-right: 16px;font-size: 14px;">
                {{ modalInfo.detail.email ? modalInfo.detail.email : '未绑定' }}
              </div>
            </div>
          </div>
          <div style="float: right;height: 96px;line-height: 96px;text-align: center;width: 160px;">
            <span style="color: #999;margin-right: 16px;font-size: 14px;">信用积分</span>
            <el-tooltip class="item" effect="dark" :content="'积分周期：' + activeDate" placement="top">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
            <span style="font-size: 24px;margin-left: 8px;font-size: 14px;" v-if="">{{
              Number(modalInfo.detail.score).toFixed(1) }}</span>
          </div>
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick" v-loading="loading">
        <el-tab-pane label="基本信息" name="1" class="tabs-basic" style="font-size: 14px;">
          <div style="background-color: white;padding: 20px;border-radius: 16px;">
            <p v-for="(field, i) in modalInfo.gridColumns" :key="i" v-show="!isEdit">
              <span v-if="field.prop == 'address'">
                <span class="label">{{ field.label }}:</span>
                {{ getAddress }}
              </span>
              <span v-else-if="field.prop == 'level'">
                <span class="label">{{ field.label }}:</span>
                {{ modalInfo.detail.level }}
              </span>
              <span v-else-if="field.prop == 'hlevelid'">
                <span class="label">{{ field.label }}:</span>
                {{ modalInfo.detail.hlevelname }}
              </span>

              <span v-else><span class="label">{{ field.label }}:</span>
                {{ modalInfo.detail[field.prop] ? modalInfo.detail[field.prop] : '' }}
              </span>
            </p>
            <el-button @click="editHandle" type="primary" size="small" style="margin-left: 122px;"
              v-show="!isEdit && type.editStatus">编辑</el-button>
            <xinmingm :modalInfo="editModalInfo" v-show="isEdit" @showEdit="showEdit" @reqDetail="reqDetail"
              @reqTableData="$emit('reqTableData')" />
          </div>
        </el-tab-pane>
        <el-tab-pane label="授权店铺" name="2">
          <el-row :gutter="20">
            <el-col :span="12" v-for="(item, i) in hcmShopList" :key="i">
              <div style="background-color: white;padding: 20px;height: 65px;margin-bottom: 20px;border-radius: 16px;">
                <div>
                  <span style="font-size: 16px;font-weight: 600;">
                    {{ item.shopName }}
                  </span>
                  <span style="font-size: 14px;padding-left: 12px;color: #606266;">
                    {{ item.wangwang }}
                  </span>
                </div>
                <div style="float: left;height: 48px;line-height: 48px;width: 350px;">
                  <div style="float: left;height: 24px;width: 24px;padding: 12px 0px;">
                    <img style="float: left;height: 24px;width: 24px;" :src="platformImg(item.platformCode)" />
                  </div>
                  <div style="float: left;">
                    <a :href="item.shopUrl" target="_blank" class="a-link">
                      {{ item.shopUrl }}
                    </a>
                    <!-- <el-link style="float: left;width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" :underline="false" type="primary" :href="item.shopUrl" target="_blank">
                              {{item.shopUrl}}
                            </el-link> -->
                  </div>
                  <div v-show="item.shopscore" class="score" style="float: right;">
                    信用积分<span>{{ item.shopscore }}</span>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-button size="small" class="btnMore" v-if="isMoreBtn && hcmShopList.length > 0"
            @click="loadMore('2')">加载更多...</el-button>
          <div class="nodata" v-if="hcmShopList.length == 0"><img src="@/assets/img/other/nodata.svg">暂无数据</div>
        </el-tab-pane>
        <el-tab-pane label="灰名单店铺" name="4" v-if="bmcid == '4316'">
          <el-row :gutter="20">
            <el-col :span="12" v-for="(item, i) in grayNameList" :key="i">
              <div
                style="background-color: white;padding: 20px;height: 65px;margin-bottom: 20px;border-radius: 16px;border: 1px solid #ccc;">
                <div>
                  <span style="font-size: 16px;font-weight: 600;">
                    {{ item.shopName }}
                  </span>
                  <span style="font-size: 14px;padding-left: 12px;color: #606266;">
                    {{ item.wangwang }}
                  </span>
                </div>
                <div style="float: left;height: 48px;line-height: 48px;width: 100%;">
                  <div style="float: left;height: 24px;width: 24px;padding: 12px 0px;">
                    <img style="float: left;height: 24px;width: 24px;" :src="platformImg(item.platformCode)" />
                  </div>
                  <div style="float: left;width: calc(100% - 160px);">
                    <a :href="item.shopUrl" target="_blank" class="a-link">
                      {{ item.shopUrl }}
                    </a>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-button size="small" class="btnMore" v-if="isMoreBtn && grayNameList.length > 0"
            @click="loadMore('4')">加载更多...</el-button>
          <div class="nodata" v-if="grayNameList.length == 0"><img src="@/assets/img/other/nodata.svg">暂无数据</div>
        </el-tab-pane>
        <el-tab-pane label="活动申报情况" name="3">
          <div class="input-wraper">
            <span>申报时间:</span>&nbsp;
            <el-date-picker v-model="commitDate" value-format="yyyy-MM-dd HH:mm:ss" size="small" type="daterange"
              range-separator="~" @change="queryData" start-placeholder="请选择" end-placeholder="请选择"
              :picker-options="pickerOptions"></el-date-picker>
          </div>
          <el-timeline>
            <el-timeline-item :timestamp="item.start_time | fullTime" placement="top" v-for="(item, i) in ActivityList"
              :key="i">
              <div style="background: #fafafa;border: 1px solid #e9e9e9;height: 58px;line-height: 58px;">
                <div style="float: left;">
                  <div style="float: left;margin-left: 20px;width: 331px;">
                    活动主题：{{ item.campaign_name }}
                  </div>
                  <div style="float: left;">
                    活动单号：{{ item.activity_number }}
                  </div>
                </div>
              </div>
              <div
                style="background: #fafafa;border: 1px solid #e9e9e9;border-top: none;height: 174px;line-height: 58px;">
                <div style="float: left;">
                  <div style="float: left;margin-left: 20px;width: 331px;">
                    平台：{{ item.dict_name }}
                  </div>
                  <div style="float: left;">
                    店铺名称：{{ item.shop_name }}
                  </div>
                </div>
                <div style="float: left;">
                  <div style="float: left;margin-left: 20px;width: 331px;">
                    预热时间：{{ item.preheating_time | fullTime }}
                  </div>
                  <div style="float: left;">
                    开始时间：{{ item.start_time | fullTime }}
                  </div>
                </div>
                <div style="float: left;">
                  <div style="float: left;margin-left: 20px;width: 331px;">
                    结束时间：{{ item.end_time | fullTime }}
                  </div>
                  <div style="float: left;">
                    活动链接数：{{ item.count }}
                  </div>
                </div>
              </div>
            </el-timeline-item>
          </el-timeline>
          <el-button size="small" class="btnMore" v-if="isMoreBtn2 && ActivityList.length > 0"
            @click="loadMore('3')">加载更多...</el-button>
          <div class="nodata" v-if="ActivityList.length == 0"><img src="@/assets/img/other/nodata.svg">暂无数据</div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <el-dialog :visible.sync="openShow" width="20%" title="提示" style="margin-top: 10%;">
      <div style="display: flex;width: 100%;justify-content:center;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
        <div v-if="switchValue == false">
          <div style="font-size: 16px;">你确认要停用该用户账号吗？</div>
          <div style="font-size: 14px;">停用后
            <span style="color: #e90e24;font-size: 14px;">账号将无法使用</span>
          </div>
        </div>
        <div v-if="switchValue == true">
          <div style="font-size: 16px;">你确认要启用该用户账号吗？</div>
          <div style="font-size: 14px;">启用后
            <span style="color: #e90e24;font-size: 14px;">账号将恢复正常使用</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="stopPhone()" size="small">确 定</el-button>
        <el-button @click="qxShow" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import xinmingm from "../xinmingm"; //编辑
import { fetchGet, fetchPost } from "@/libs/reqCommon";
import moment from "moment";
import { getMonthBetween } from "@/libs/date";
export default {

  name: 'shopRightDetail',
  components: { xinmingm },
  props: {
    modalInfo: {
      type: Object,
      default: () => { }
    },
    editModalInfo: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      grayNameList: [],
      pickerOptions: {
        shortcuts: [{
          text: '今日',
          onClick: (picker) => {
            this.getRecentDate(picker, 1);
          }
        }, {
          text: '近7日',
          onClick: (picker) => {
            this.getRecentDate(picker, 7);
          }
        }, {
          text: '近15日',
          onClick: (picker) => {
            this.getRecentDate(picker, 15);
          }
        }, {
          text: '近30日',
          onClick: (picker) => {
            this.getRecentDate(picker, 30);
          }
        }, {
          text: '近90日',
          onClick: (picker) => {
            this.getRecentDate(picker, 90);
          }
        }, {
          text: '近365日',
          onClick: (picker) => {
            this.getRecentDate(picker, 365);
          }
        }]
      },
      activeNames: ['1'],
      openShow: false,
      switchValue: true,
      activeDate: '',
      loading: true,
      activeName: "1",
      commitDate: [],//申报时间
      ActivityList: [],//活动申报情况
      isMoreBtn: false,

      hcmShopList: [],//授权店铺
      params: { pageSize: 10 },
      isMoreBtn2: false,

      query: {
        pageNum: 1, pageSize: 10
      },
      isEdit: false,
      type: {}
    }
  },
  mounted() {
    this.type = JSON.parse(window.localStorage.userData)
    console.log(this.type)
    this.bmcid = this.type.bmcid
    console.log(this.bmcid,'bmcidbmcidbmcid')
  },
  computed: {
    getAddress() {
      let province = this.modalInfo.detail.province ? this.modalInfo.detail.province : '';
      let city = this.modalInfo.detail.city ? this.modalInfo.detail.city : '';
      let strict = this.modalInfo.detail.strict ? this.modalInfo.detail.strict : '';
      let address = this.modalInfo.detail.address ? this.modalInfo.detail.address : '';
      return province + city + strict + address
    }
  },
  watch: {
    modalInfo(newVal) {
      if (newVal) {
        this.getPointsCycle();
      }
    }
  },
  filters: {
    levelFilter: function (value) {
      value = Number(value);
      if (value == 1) return '一级经销商'
      else if (value == 2) return '二级经销商'
      else if (value == 3) return '三级经销商'
      else if (value == 4) return '四级经销商'
      else if (value == 5) return '五级经销商'
    }
  },
  methods: {
    qxShow() {
      let row = {}
      row.id = this.modalInfo.detail.id
      this.$emit("linkDetailDetail", row)
      this.openShow = false
    },
    switchShow() {
      this.openShow = true
    },
    stopPhone() {
      let params = {
        userIds: this.modalInfo.detail.userid,
        usertype: 'c'
      }
      if (this.switchValue == true) {
        params.status = 1
      } else {
        params.status = 0
      }
      fetch({
        url: "hcm/user/StartOrStop",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.openShow = false;
          let row = {}
          row.id = this.modalInfo.detail.id
          this.$emit("linkDetailDetail", row)
        }
      })
        .catch(err => {

        })
    },
    // 获取积分周期时间
    getPointsCycle() {
      fetch({
        url: "hcm/hcmReport/getPointsCycle",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          if (this.modalInfo.detail && this.modalInfo.detail.status == 1) {
            this.switchValue = true
          } else {
            this.switchValue = false
          }
          if (res.data) {
            this.getNowDataRang(res.data)
          }
        }
      })
    },
    // 积分周期时间筛选
    getNowDataRang(data) {
      this.integralCycel = data;
      const formatType = "YYYY-MM-DD";
      let now = moment(new Date()).format(formatType).slice(0, 7);
      this.integralCycel.map((item, index) => {
        let time = item.split("--");
        let result = getMonthBetween(time[0], time[1]);
        for (let key in result) {
          result[key].map((v) => {
            if (v === now) {
              this.activeDate = item;
            }
          });
        }
      });
    },
    platformImg(platformCode) {
      let img = "";
      try {
        img = require('@/assets/img/platform/pla_' + platformCode + '.png')
      } catch (err) {
        img = ""
      }
      return img
    },
    getRecentDate(picker, n) {
      if (!n) {
        n = 30
      }
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
      if (picker) {
        picker.$emit('pick', [start, end]);
      }
      if (n === 1) {
        this.query.begintime = this.$options.filters['fullTime'](end).substring(0, 10) + ' 00:00:00';
        this.query.endtime = this.$options.filters['fullTime'](end).substring(0, 10) + ' 23:59:59';
        this.commitDate[0] = this.$options.filters['fullTime'](end).substring(0, 10) + ' 00:00:00';
        this.commitDate[1] = this.$options.filters['fullTime'](end).substring(0, 10) + ' 23:59:59';
      } else {
        this.query.begintime = this.$options.filters['fullTime'](start).substring(0, 10) + ' 00:00:00';
        this.query.endtime = this.$options.filters['fullTime'](end).substring(0, 10) + ' 23:59:59';
        this.noticeTime[0] = this.$options.filters['fullTime'](start).substring(0, 10) + ' 00:00:00';
        this.noticeTime[1] = this.$options.filters['fullTime'](end).substring(0, 10) + ' 23:59:59';
      }
    },
    // // 前三个月时间
    // getRecentDate(picker) {
    //     const end = new Date();
    //     const start = new Date();
    //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
    //     if (picker) {
    //         picker.$emit("pick", [start, end]);
    //     }
    //     this.commitDate[0] = start;
    //     this.commitDate[1] = end;
    //     this.query.begintime = this.$options.filters['fullTime'] (start);
    //     this.query.endtime = this.$options.filters['fullTime'] (end);
    // },
    // 根据时间查询活动申报情况
    queryData(date) {
      let query = {
        ...this.query,
        begintime: date[0],
        endtime: date[1],
        dealer_id: this.modalInfo.detail.id,
      }
      let url = "/hcm/campgign/getCampaignsituation";
      this.ActivityListData(url, query);
    },
    // 活动申报情况数据请求
    ActivityListData(url, query) {
      this.loading = true;
      fetchGet(url, query).then(res => {
        if (res.status == "10000") {
          if (res.data.details) {
            this.ActivityList = res.data.details;
            if (res.data.details.length < this.query.pageSize)
              this.isMoreBtn2 = false;
            else this.isMoreBtn2 = true;
          }
          this.loading = false;
        }
      });
    },
    // 授权店铺数据请求
    hcmShopListData(url, query) {
      this.loading = true;
      fetchGet(url, query).then(res => {
        if (res.status == "10000") {
          if (res.data.length < this.params.pageSize)
            this.isMoreBtn = false;
          else this.isMoreBtn = true;
          this.hcmShopList = res.data;
        }
        this.loading = false;
      });
    },
    //灰名单店铺数据请求
    hcmGrayShopListData(url, query) {
      this.loading = true;
      fetchGet(url, query).then(res => {
        if (res.status == "10000") {
          if (res.data.length < this.query.pageSize)
            this.isMoreBtn = false;
          else this.isMoreBtn = true;
          this.grayNameList = res.data;
        }
        this.loading = false;
      });
    },
    handleClick(tab) {
      let url = "/hcm/campgign/getCampaignsituation"
      let query = {
        dealer_id: this.modalInfo.detail.id,
        ...this.query
      }
      if (tab.name == "3") {  //活动申报情况
        this.ActivityListData(url, query);
      } else if (tab.name == "2") {  //授权店铺
        url = "/hcm/hcmShop/GetList"
        query = {
          pageNo: 1,
          pageSize: this.params.pageSize,
          dealerid: this.modalInfo.detail.id
        }
        this.hcmShopListData(url, query)
      } else if (tab.name == "4") {  //授权店铺
        url = "/hcm/hcmShop/GetListblack"
        query = {
          pageNo: 1,
          pageSize: this.query.pageSize,
          dealerid: this.modalInfo.detail.id
        }
        this.hcmGrayShopListData(url, query)
      }
    },
    loadMore(index) {
      if (index == 2) {
        this.params.pageSize = this.params.pageSize + 10;
        this.handleClick({ name: "2" });
      } else {
        this.query.pageSize = this.query.pageSize + 10;
        this.handleClick({ name: "3" });
      }
    },
    showEdit(isShow) {
      this.isEdit = isShow;
    },
    editHandle() {
      this.isEdit = true;
      let payload = {
        index: null, row: this.modalInfo.row
      }
      this.$emit('editClick', payload)
    },
    reqDetail(payload) {
      this.$emit('reqDetail', payload)
    }
  }
}
</script>
<style lang="scss">
@import 'src/style/shopDetail';

.el-drawer {
  width: 840px !important;
}

.a-link {
  float: left;
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: rgb(64, 158, 255);
  text-decoration: none;
  line-height: 58px;
  margin-left: 10px;
}

.shop-link {
  width: calc(100% - 90px) !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle !important;
}
</style>
